import { _defineProperty } from "@slyte/core/src/lyte-utils";
import { Route } from "../../../node_modules/@slyte/router/index.js";
let ButtonComp;

// import { RightPanelLayout } from '/components/javascript/layout-components/right-panel-layout';

class Button extends Route {
  render() {
    return { outlet: '#zcatcomponent', component: ButtonComp };  
    // return { outlet: '#zcatcomponent', component: RightPanelLayout };
  }

  static actions(arg1) {
    return Object.assign(super.actions({}), arg1);
  }

  _() {
    _;
  }

  getRequirements() {
    arguments[1].push(import(
      /* webpackChunkName: "components/javascript/zcat-components/button-comp" */
      "../../../components/javascript/zcat-components/button-comp"
    ).then(function(res) {
      ButtonComp = res.ButtonComp;
    }));

    
;
  }
}

export { Button };
